<template>
  <div class="orderform w-full px-2">
    <h1 class="mb-6">Bestellung abschließen</h1>

    <div v-if="errors[0]" class="bg-red-lightest border border-red-light text-red-darker px-4 my-2 py-3 rounded relative"
      role="alert">
      <strong class="font-bold">Oh no!</strong>
      <span class="block sm:inline" v-for="error in errors" :key="error" v-html="error"></span>
    </div>

    <div v-if="emptyBasket && order === null"
      class="bg-orange-lightest border-l-4 border-orange text-orange-darkest p-4 mb-8" role="alert">
      <p class="font-bold">Noch nichts im Warenkorb</p>
      <p>
        Du hast noch keine Artikel im Warenkorb. Beste Zeit das zu ändern!
        <router-link tag="a" :to="{ name: 'Shop', params: { hostUrl: hostUrl } }"
          class="block text-orange-darkest pt-2">zur Speisekarte</router-link>
      </p>
    </div>

    <div v-if="!isOfficeOrderClient && !emptyBasket && !hasValidMbwDeviation && order === null && item_homedelivery"
      class="bg-orange-lightest border-l-4 border-orange text-orange-darkest p-4 mb-8" role="alert">
      <p class="font-bold">Mindestbestellwert noch nicht erreicht</p>
      <p>Dir fehlen noch {{ mbwDeviation | pricetag }} Warenwert um deine Bestellung abschließen zu können</p>
    </div>

    <div v-if="getBasket.currenthost && getBasket.currenthost.item_homedelivery != 'Y' && !isOfficeOrderClient"
      class="flex items-center bg-green-heinz text-black text-sm font-bold px-4 py-3 my-4" role="alert">
      <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <path
          d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
      </svg>
      <p>Der gewählte Anbieter bietet <template
          v-if="getBasket.currenthost.item_active_delivery === 'N'">vorübergehend</template>
        keine Lieferung an</p>
    </div>

    <form v-if="(!emptyBasket && order === null) || paypalPaymentInProgress" class="w-full" ref="orderform" v-on:submit.prevent="sendorder">
      <div v-if="!isOfficeOrderClient && getBasket.currenthost" class="mb-6">
        <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-delivery">
          <span>Zustellung</span>
        </label>
        <div class="relative">
          <select v-if="!hasTable" v-model="item_homedelivery"
            class="block appearance-none w-full border border-green-heinz text-grey-darkest py-3 px-4 pr-8 rounded"
            id="grid-delivery">
            <option :value="true" v-if="getBasket.currenthost.item_homedelivery === 'Y' && !isPosApp">Liefern lassen
            </option>
            <option :value="false" v-if="getBasket.currenthost.item_active_pickup === 'Y'">Selbst in {{
              getBasket.currenthost.item_ort }} abholen</option>
            <option :value="0" v-if="getBasket.currenthost.item_allow_bookatable === 'Y'">
              Tisch reservieren und vor Ort genießen
            </option>
          </select>
          <div v-if="!hasTable"
            class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darkest">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
          <div v-if="hasTable">
            Wird dir direkt an den Tisch ({{ getTable.tableTitle }}) geliefert 👌<br />
            <button v-on:click="abortTableOrder()"
              class="bg-green-heinz hover:bg-green-heinz-light text-sm text-black py-1 px-2 my-1 rounded">Tischbestellung
              abbrechen?</button>
          </div>
        </div>
      </div>

      <div v-if="!deliverySelectionIsToday && !isOfficeOrderClient"
        class="w-full flex items-center bg-green-heinz text-black text-sm font-bold px-4 py-3 my-4" role="alert">
        <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path
            d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
        </svg>
        <p>Obacht! Du bestellst nicht für heute.</p>
      </div>

      <div
        v-if="((!isOfficeOrderClient && hasValidMbwDeviation) || (!item_homedelivery && !isOfficeOrderClient)) && !hasTable"
        class="flex flex-wrap -mx-3 mb-6">
        <div class="w-full px-3 mb-6 md:mb-0">
          <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-delivery-time">
            <span v-if="item_homedelivery">Wunsch-Lieferzeit</span>
            <span v-if="!item_homedelivery && !option_bookatable">Wunsch-Abholzeit</span>
            <span v-if="!item_homedelivery && option_bookatable">Wunsch-Tischreservierung</span>
          </label>
          <div class="relative">
            <select required v-model="delivery"
              class="block appearance-none w-full border border-green-heinz text-grey-darkest py-3 px-4 pr-8 rounded"
              id="grid-delivery-time">
              <optgroup v-for="deliveryOption in deliveryOptions" :label="deliveryOption.caption"
                :key="deliveryOption.caption">
                <option :value="deliveryOption.value" v-if="deliveryOption.type == 'option'">{{ deliveryOption.caption
                  }}
                </option>
                <option :value="item.value" v-for="item in deliveryOption.items">{{ item.caption }}
                </option>
              </optgroup>
            </select>
            <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div>
          </div>
          <p v-if="submitted && !hostIsOpen() && delivery == 0" class="text-red text-sm italic">
            Bitte wähle einen <span v-if="item_homedelivery">Liefertermin</span> <span
              v-if="!item_homedelivery">Abholtermin</span> aus
          </p>
          <p v-if="delivery !== 0" class="pt-2 text-grey-darker text-sm">
            Bitte beachte, dass Wunschtermine seitens des Restaurants manchmal nicht umsetzbar sind.<br />
            Du erhälst kurz nach deiner Bestellung eine Info vom Restaurant mit der versprochenen <template
              v-if="item_homedelivery">Lieferzeit</template><template v-if="!item_homedelivery">Abholzeit</template>.
          </p>
        </div>
      </div>

      <div v-if="(!isOfficeOrderClient && hasValidMbwDeviation) || (!item_homedelivery && !isOfficeOrderClient)"
        class="flex flex-wrap -mx-3 mb-6">
        <div class="w-full px-3 mb-6 md:mb-0">
          <span class="block uppercase uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-payment">
            Zahlung
          </span>
          <div class="relative">
            <div class="paymentSelector" style="align-content:stretch;">
              <div v-if="paymentSum == 0" class="paymentIcon" :class="{ active: item_payment === 'nachnahme' }"
                tabindex="0" v-on:keydown.enter.prevent="item_payment = 'nachnahme'"
                @click="item_payment = 'nachnahme'">
                <img src="/static/icons/cash.png" alt="Gutschein" />
                <span>Gutschein</span>
              </div>
              <div v-if="paymentSum > 0 && getBasket.currenthost && getBasket.currenthost.item_payment_cash == 'Y'"
                class="paymentIcon" :class="{ active: item_payment === 'nachnahme' }"
                tabindex="0" v-on:keydown.enter.prevent="item_payment = 'nachnahme'"
                @click="item_payment = 'nachnahme'">
                <img src="/static/icons/cash.png" alt="" />
                <span>Barzahlung</span>
              </div>
              <div v-if="paymentSum > 0 && getBasket.currenthost && getBasket.currenthost.item_webpayment == 'Y'"
                class="paymentIcon" :class="{ active: item_payment === 'paypal' }"
                tabindex="0" v-on:keydown.enter.prevent="item_payment = 'paypal'" @click="item_payment = 'paypal'">
                <img src="/static/icons/paypal_payment.png" alt="" />
                <span>PayPal</span>
              </div>
              <div
                v-if="paymentSum > 0 && hasApplePay && getBasket.currenthost && getBasket.currenthost.item_webpayment == 'Y'"
                class="paymentIcon" :class="{ active: item_payment === 'applepay' }"
                tabindex="0" v-on:keydown.enter.prevent="item_payment = 'applepay'" @click="item_payment = 'applepay'">
                <img src="/static/icons/applepay.svg" alt="" />
                <span>Apple Pay</span>
              </div>
              <div
                v-if="paymentSum > 0 && hasGooglePay && getBasket.currenthost && getBasket.currenthost.item_webpayment == 'Y'"
                class="paymentIcon" :class="{ active: item_payment === 'googlepay' }"
                tabindex="0" v-on:keydown.enter.prevent="item_payment = 'googlepay'"
                @click="item_payment = 'googlepay'">
                <img src="/static/icons/googlepay.png" alt="" />
                <span>Google Pay</span>
              </div>
              <div v-if="paymentSum > 0 && getBasket.currenthost && getBasket.currenthost.item_payment_ec == 'Y'"
                class="paymentIcon" :class="{ active: item_payment === 'ec' }"
                tabindex="0" v-on:keydown.enter.prevent="item_payment = 'ec'" @click="item_payment = 'ec'">
                <img src="/static/icons/ec.png" alt="EC Kartenzahlung" />
                <span>EC Zahlung</span>
              </div>
            </div>
            <p v-if="submitted && !item_payment" class="text-red text-sm italic">Leider musst du dein Essen bezahlen -
              bitte
              wähle eine Zahlmethode</p>
          </div>
        </div>
      </div>
      <div
        v-if="isOnlinePayment && getBasket.currenthost.item_webpayment_tip === 'Y' && ((!isOfficeOrderClient && hasValidMbwDeviation) || (!item_homedelivery && !isOfficeOrderClient))"
        class="flex flex-wrap -mx-3 mb-6">
        <div class="w-1/3 px-3 mb-6 md:mb-0">
          <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-tip">
            Trinkgeld
          </label>
          <input v-model="item_tip"
            id="grid-tip"
            class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4"
            type="number" min="0" step="0.01" placeholder="" />
        </div>
        <div class="w-2/3 flex flex-wrap px-3 mb-6 md:mb-0">
          <span class="block w-full tracking-wide text-sm">&nbsp;</span>
          <input type="button" v-on:click="tip(0)"
            class="bg-green-heinz mx-1 hover:bg-green-heinz-light text-block py-3 px-2 mb-8 w-1/3 md:w-1/6 rounded cursor-pointer hidden md:block"
            value="aufrunden" />
          <input type="button" v-on:click="tip(0)"
            class="bg-green-heinz mx-1 hover:bg-green-heinz-light text-block py-3 px-2 mb-8 w-1/3 md:w-1/6 rounded cursor-pointer md:hidden"
            value="+" />
          <input type="button" v-on:click="tip(5)"
            class="bg-green-heinz mx-1 hover:bg-green-heinz-light text-block py-3 px-2 mb-8 w-1/3 md:w-1/6 rounded cursor-pointer"
            value="5%" />
          <input type="button" v-on:click="tip(10)"
            class="bg-green-heinz mx-1 hover:bg-green-heinz-light text-block py-3 px-2 mb-8 w-1/3 md:w-1/6 rounded cursor-pointer"
            value="10%" />
          <input type="button" v-on:click="tip(15)"
            class="bg-green-heinz mx-1 hover:bg-green-heinz-light text-block py-3 px-2 mb-8 w-1/3 md:w-1/6 rounded cursor-pointer"
            value="15%" />
          <input type="button" v-on:click="tip(20)"
            class="bg-green-heinz mx-1 hover:bg-green-heinz-light text-block py-3 px-2 mb-8 hidden md:inline-block md:w-1/6 rounded cursor-pointer"
            value="20%" />
        </div>
      </div>

      <div v-if="isExpressCheckout && !hasTable"
        class="flex items-center bg-green-heinz text-block text-sm font-bold px-4 py-3 my-4" role="alert">
        <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path
            d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
        </svg>
        <p>Deine Adressdaten kannst du im Anschluss einfach bei {{ item_payment }} auswählen.</p>
      </div>

      <template v-if="!isExpressCheckout && !hasTable">
        <div v-if="isLoggedIn && filteredUserLocations.length > 0 && !isOfficeOrderClient && hasValidMbwDeviation"
          class="my-8">
          <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-locations">
            Gespeicherte Adressen ({{ filteredUserLocations.length }}/{{ userLocations.length }})
          </label>
          <select v-model="item_customer_location" id="grid-locations"
            class="block appearance-none w-full border border-green-heinz text-grey-darker py-3 px-4 pr-8 rounded">
            <option :value="false">➕ neue Adresse hinzufügen</option>
            <option v-for="location in filteredUserLocations" :key="location.id" :value="location.id">
              📍
              <template v-if="location.item_firma">{{ location.item_firma }}</template>
              <template v-else>{{ location.item_vorname }} {{ location.item_name }}</template>
              <template v-if="item_homedelivery"> |
                {{ location.item_strasse }} {{ location.item_hausnummer }} |
                {{ location.item_plz }} {{ location.item_ort_einfach }}
              </template>
            </option>
          </select>
          <router-link tag="a" :to="{ name: 'Einstellungen' }"
            class="text-grey-darker hover:text-black text-sm">Adressen
            bearbeiten</router-link>
        </div>

        <div v-if="!item_customer_location && !isOfficeOrderClient && hasValidMbwDeviation"
          class="flex flex-wrap -mx-3 mb-6">
          <div class="w-full px-3 mb-6 md:mb-0">
            <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-company">
              Firma (optional)
            </label>
            <input v-model="item_firma"
              class="appearance-none block w-full background-grey-lighter text-grey-darker border border-green-heinz rounded py-3 px-4"
              id="grid-company" type="text" autocomplete="org" placeholder="" />
          </div>
        </div>
        <div v-if="!item_customer_location && !isOfficeOrderClient && (hasValidMbwDeviation || !item_homedelivery)"
          class="flex flex-wrap -mx-3 mb-6">
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-first-name">
              Vorname
            </label>
            <input v-model="item_vorname" required
              class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4"
              id="grid-first-name" type="text" autocomplete="given-name" placeholder="" />
            <p v-if="submitted && !item_vorname" class="text-red text-sm italic">Bitte verrate uns deinen Vornamen</p>
          </div>
          <div class="w-full md:w-1/2 px-3">
            <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-last-name">
              Nachname
            </label>
            <input v-model="item_name" required
              class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4"
              id="grid-last-name" type="text" autocomplete="family-name" placeholder="" />
            <p v-if="submitted && !item_name" class="text-red text-sm italic">Bitte verrate uns deinen Nachnamen</p>
          </div>
        </div>
        <div v-if="!item_customer_location && !isOfficeOrderClient && hasValidMbwDeviation && item_homedelivery"
          class="flex flex-wrap -mx-3 mb-6">
          <div class="w-3/4 px-3 mb-6 md:mb-0">
            <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-street">
              Straße
            </label>
            <input v-model="item_strasse" required
              class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4"
              id="grid-street" type="text" autocomplete="address-line1" placeholder="" />
            <p v-if="submitted && !item_strasse" class="text-red text-sm italic">Bitte verrate uns deine Straße</p>
          </div>
          <div class="w-1/4 px-3">
            <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-street-no">
              Hausnr.
            </label>
            <input v-model="item_hausnummer" required
              class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4"
              id="grid-street-no" type="text" autocomplete="off" placeholder="" />
            <p v-if="submitted && !item_hausnummer" class="text-red text-sm italic">Bitte verrate uns deine Hausnummer
            </p>
          </div>
        </div>
        <div v-if="!item_customer_location && !isOfficeOrderClient && hasValidMbwDeviation && item_homedelivery"
          class="flex flex-wrap -mx-3 mb-6">
          <div class="w-full px-3 mb-6 md:mb-0">
            <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold"
              for="grid-address-additions">
              Adresszusatz / Hinweise (optional)
            </label>
            <input v-model="item_address_addon"
              class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4"
              id="grid-address-additions" type="text" autocomplete="address-level4" placeholder="">
          </div>
        </div>
        <div v-if="!item_customer_location && !isOfficeOrderClient && item_homedelivery"
          class="flex flex-wrap -mx-3 mb-6">
          <div class="w-full px-3 mb-6 md:mb-0">
            <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-city">
              Lieferort
            </label>
            <div class="relative">
              <select v-model="item_geoid" required
                class="block appearance-none w-full border border-green-heinz text-grey-darkest py-3 px-4 pr-8 rounded"
                id="grid-city">
                <option value="">-- bitte wählen --</option>
                <option :value="geoOption.id" v-for="geoOption in geoOptions" :key="geoOption.id">
                  {{ geoOption.item_plz }} {{ geoOption.item_ort_einfach }}
                  <template v-if="geoOption.item_ortsteil != geoOption.item_ort_einfach">{{ geoOption.item_ortsteil
                    }}</template>
                </option>
              </select>
              <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>
              <p v-if="submitted && !item_geoid" class="text-red text-sm italic">Bitte wähle deinen Lieferort aus</p>
            </div>
          </div>
        </div>
      </template>
      <template v-if="!isLoggedIn && !isExpressCheckout && !hasTable">
        <div v-if="(!isOfficeOrderClient && hasValidMbwDeviation) || (!item_homedelivery && !isOfficeOrderClient)"
          class="flex flex-wrap -mx-3 mb-6">
          <div class="w-full px-3 mb-6 md:mb-0">
            <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-cellphone">
              Handynummer
            </label>
            <input v-model="item_handy" required
              class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4"
              id="grid-cellphone" type="tel" autocomplete="tel" placeholder="" />
            <p v-if="submitted && !validCellphone" class="text-red text-sm italic">Bitte verrate uns deine Handynummer.
              Wir schicken dir eine WhatsApp oder SMS zum Status deiner Bestellung.</p>
          </div>
        </div>
        <div
          v-if="!isPosApp && ((!isOfficeOrderClient && hasValidMbwDeviation) || (!item_homedelivery && !isOfficeOrderClient))"
          class="flex flex-wrap -mx-3 mb-6">
          <div class="w-full px-3 mb-6 md:mb-0">
            <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-mail">
              E-Mail Adresse
            </label>
            <input v-model="item_email" required
              class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4"
              id="grid-mail" type="email" autocomplete="email" placeholder="" />
          </div>
        </div>
      </template>

      <div v-if="(!isOfficeOrderClient && hasValidMbwDeviation) || (!item_homedelivery && !isOfficeOrderClient)"
        class="flex flex-wrap -mx-3 mb-2 md:mb-6">
        <div class="w-full px-3 mb-6 md:mb-0">
          <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-wishes">
            Anmerkungen & Wünsche (optional)
            <div v-if="isOnlinePayment && hasExtraContent"
              class="w-full flex items-center bg-green-heinz text-black text-sm font-bold px-4 py-3 my-4" role="alert">
              <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path
                  d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
              </svg>
              <p>Bitte beachte, dass du möglicherweise einen Aufpreis in Bar zuzahlen musst, wenn du hier
                kostenpflichtige
                Wünsche äußerst.</p>
            </div>
          </label>
          <textarea v-model="item_xtra"
            class="appearance-none block w-full h-32 text-grey-darker border border-green-heinz rounded py-3 px-4"
            id="grid-wishes"></textarea>
        </div>
      </div>

      <div v-if="getBasket.currenthost.item_vytal === 'Y' && !isOfficeOrderClient && hasValidMbwDeviation && !hasTable">
        <div id="vytal-login"></div>
      </div>

      <div
        v-if="((!isOfficeOrderClient && hasValidMbwDeviation) || (!item_homedelivery && !isOfficeOrderClient)) && getBasket.currenthost && getBasket.currenthost.item_allow_cut == 'Y'"
        class="flex flex-wrap -mx-3 mb-2">
        <div class="w-full px-3 mb-2 md:mb-0">
          <label class="block text-grey-darker font-bold">
            <input v-model="option_cut" class="mr-2" type="checkbox">
            <span class="text-sm">
              Pizza schneiden
            </span>
          </label>
        </div>
      </div>
      <div v-if="(!isOfficeOrderClient && hasValidMbwDeviation) || (!item_homedelivery && !isOfficeOrderClient)"
        class="flex flex-wrap -mx-3 mb-2">
        <div class="w-full px-3 mb-2 md:mb-0">
          <label class="block text-grey-darker font-bold">
            <input v-model="option_voucher" class="mr-2" type="checkbox">
            <span class="text-sm">
              Bewirtungsbeleg gewünscht
            </span>
          </label>
        </div>
      </div>
      <div
        v-if="!isLoggedIn && !isPosApp && ((!isOfficeOrderClient && hasValidMbwDeviation) || (!item_homedelivery && !isOfficeOrderClient))"
        class="flex flex-wrap -mx-3 mb-2">
        <div class="w-full px-3 mb-2 md:mb-0">
          <label class="block text-grey-darker font-bold">
            <input v-model="storeCustomerData" class="mr-2" type="checkbox">
            <span class="text-sm">
              Eingaben für nächste Bestellung merken
            </span>
          </label>
        </div>
      </div>
      <div
        v-if="isLoggedIn && item_homedelivery && !isOfficeOrderClient && hasValidMbwDeviation && !item_customer_location && !hasTable"
        class="flex flex-wrap -mx-3 mb-2">
        <div class="w-full px-3 mb-2 md:mb-0">
          <label class="block text-grey-darker font-bold">
            <input v-model="storeCustomerAddress" class="mr-2" type="checkbox">
            <span class="text-sm">
              Neue Adresse speichern
            </span>
          </label>
        </div>
      </div>
      <div v-if="(!isOfficeOrderClient && hasValidMbwDeviation) || (!item_homedelivery && !isOfficeOrderClient)"
        class="flex flex-wrap -mx-3 mb-2">
        <div class="w-full px-3 mb-2 md:mb-0">
          <div class="block text-grey-darker font-bold text-xs">
            <label>
              <input v-model="option_agb" required class="mr-2" type="checkbox">
              <span>
                Ich bestätige, dass ich die <router-link tag="a" :to="{ name: 'Datenschutz' }"
                  class="text-grey-darker hover:text-black">Datenschutzvereinbarung</router-link> gelesen habe und sie
                uneingeschränkt akzeptiere. Ich gehe einen Kaufvertrag mit dem gewählten Anbieter ({{
                  getBasket.currenthost.item_name }}, {{ getBasket.currenthost.item_owner }}, {{
                  getBasket.currenthost.item_street }} {{ getBasket.currenthost.item_houseno }}, {{
                  getBasket.currenthost.item_plz }} {{ getBasket.currenthost.item_ort }}) ein. Meine IP-Adresse sowie alle
                auf
                dieser Seite ersichtlichen Daten werden zum Zwecke der Bestellabwicklung, Abrechnung und Bestellhistorie
                gespeichert und zur Verarbeitung an die <a href="/impressum" class="text-grey-darker hover:text-black"
                  target="_blank">{{ company.name }}</a> sowie den gewählten Anbieter weitergegeben. Wir werden dich per
                E-Mail und WhatsApp bzw. SMS zu deiner Bestellung kontaktieren. Du kannst uns jedoch nach Abschluss
                deiner
                Bestellung jederzeit per E-Mail mit Angabe deiner Bestellnummer darum bitten deine Daten zu
                anonymisieren.
                Missbrauch wird verfolgt.
              </span>
            </label>
            <a class="text-grey-darker" href="javascript:void(0);"
              @click="showNotificationSettings = !showNotificationSettings">Benachrichtigungseinstellungen
              anpassen<template v-if="showNotificationSettings">:</template><template v-else>?</template></a>
            <div :class="{ hidden: !showNotificationSettings }">
              <label class="block"><input type="checkbox" class="mr-2" v-model="option_email"><template
                  v-if="option_email && option_whatsapp">auch</template><template
                  v-if="option_email && !option_whatsapp">nur</template><template v-if="!option_email">nicht</template>
                per
                E-Mail benachrichtigen</label>
              <label class="block"><input type="checkbox" class="mr-2" v-model="option_whatsapp"><template
                  v-if="option_email && option_whatsapp">auch</template><template
                  v-if="!option_email && option_whatsapp">nur</template><template
                  v-if="!option_whatsapp">nicht</template>
                per WhatsApp bzw. SMS benachrichtigen</label>
            </div>
          </div>
          <p v-if="submitted && !option_agb" class="text-red text-sm italic">Du musst unsere Datenschutzbedinungen
            akzeptieren um fortfahren zu können</p>
        </div>
      </div>

      <template v-if="!isExpressCheckout && (hasValidMbwDeviation || !item_homedelivery || isOfficeOrderClient || paypalPaymentInProgress)">
        <template v-if="paypalPaymentInProgress || (item_payment === 'paypal' && !isOfficeOrderClient)">
          <input v-if="!paypalButtonReady" type="submit" :value="submitLabel" @click="paypalLegacyMode=true;" class="bg-green-heinz hover:bg-green-heinz-light text-black py-4 px-2 mb-8 w-full rounded hover:cursor-pointer" />
          <div v-if="item_payment = 'paypal'">
            <div class="paypal-button-container"></div>
          </div>
        </template>

        <input v-else type="submit" :value="submitLabel" class="bg-green-heinz hover:bg-green-heinz-light text-black py-4 px-2 mb-8 w-full rounded hover:cursor-pointer" />
      </template>

      <div v-show="isExpressCheckout && !isOfficeOrderClient && ((hasValidMbwDeviation) || !item_homedelivery)">
        <div v-if="paymentError" class="bg-orange-lightest border-l-4 border-orange text-orange-dark p-4 mb-8"
          role="alert">
          {{ item_payment }} ist aktuell nicht verfügbar. Bitte wähle eine andere Zahlungsmethode.
        </div>
        <div id="payment-request-button"></div>
      </div>
    </form>
  </div>
</template>

<script>
import endpoints from '../endpoints'
import axios from 'axios'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import moment from 'moment'

export default {
  name: 'Orderform',

  data() {
    return {
      hostId: window.hostId,
      hostUrl: this.$route.params.hostUrl,
      deliveryOptions: {},
      geoOptions: {},
      submitted: false,
      order: null,
      stripeApiKey: process.env.VUE_APP_STRIPE_KEY,
      stripe: window.Stripe ? window.Stripe(process.env.VUE_APP_STRIPE_KEY) : null,
      stripeHasActivePayment: false,
      stripeEv: null,
      stripePaymentRequest: null,
      errors: [],
      readyForPaypalPayment: false,
      paymentError: false,
      storeCustomerAddress: true,
      showNotificationSettings: false,
      paypalButtonReady: false,
      paypalPaymentInProgress: false,
      paypalLegacyMode: false
    }
  },

  watch: {
    item_geoid(newVal, oldVal) {
      axios.post(endpoints.setGeoId, { 'geoid': newVal })
        .then(response => {
          this.updateBasket()
          this.updateStripePaymentRequest()
        })
        .catch(e => {
          this.errors.push('Lieferort konnten nicht gesetzt werden 😭')
        })
    },

    item_handy(newVal) {
      if (newVal.substring(0, 3) === '+49') {
        this.item_handy = newVal.replace('+49', '0')
      }
    },

    item_homedelivery(newVal) {
      this.option_bookatable = (newVal === 0)

      this.$nextTick(() => {
        this.getDeliveryOptions()
        this.updateStripePaymentRequest()
      })
    },

    item_payment() {
      this.paymentError = false
      this.initStripe()

      this.$nextTick(() => {
        this.initPayPal()
      })
    },

    getBasket() {
      this.$nextTick(() => {
        this.updateStripePaymentRequest()
        this.updateHomeDelivery()
      })
    },

    paymentSum() {
      this.$nextTick(() => {
        this.updateStripePaymentRequest()
      })
    },

    item_customer_location(customerLocation) {
      const selectedLocation = this.userLocations.find(item => item.id === customerLocation)
      const fieldMap = [
        'item_firma',
        'item_vorname',
        'item_name',
        'item_strasse',
        'item_hausnummer',
        'item_geoid',
        'item_address_addon'
      ]

      fieldMap.forEach(item => {
        if (customerLocation) {
          this[item] = selectedLocation[item]
        } else if (item !== 'item_geoid') {
          this[item] = null
        }
      })
    },

    option_email() {
      if (!this.option_email && !this.option_whatsapp) {
        this.option_whatsapp = true
      }
    },

    option_whatsapp() {
      if (!this.option_email && !this.option_whatsapp) {
        this.option_email = true
      }
    },

    delivery() {
      console.log('this.validateSelectedDeliveryOption() watch', this.validateSelectedDeliveryOption())
    }
  },

  computed: {
    ...mapGetters([
      'getBasket',
      'basketSum',
      'basketSumWoMbw',
      'shippingCosts',
      'emptyBasket',
      'basketSize',
      'productSum',
      'mbwDeviation',
      'isOfficeOrderClient',
      'officeOrder',
      'isLoggedIn',
      'userLocations',
      'hasTable',
      'getTable'
    ]),

    ...mapFields([
      'content.delivery',
      'content.item_table',
      'content.item_customer_location',
      'content.item_homedelivery',
      'content.item_firma',
      'content.item_vorname',
      'content.item_name',
      'content.item_strasse',
      'content.item_hausnummer',
      'content.item_geoid',
      'content.item_address_addon',
      'content.item_handy',
      'content.item_tip',
      'content.item_email',
      'content.item_payment',
      'content.item_xtra',
      'content.option_cut',
      'content.option_bookatable',
      'content.option_drop',
      'content.option_voucher',
      'content.option_agb',
      'content.option_email',
      'content.option_whatsapp',
      'content.storeCustomerData',
      'content.item_vytal'
    ]),

    submitLabel: function () {
      if (this.isOfficeOrderClient) return 'Mitbestellung abschließen'
      return 'Einkauf abschließen'
    },

    validCellphone: function () {
      if (_.size(this.item_handy) < 9) return false
      const regex = /^([\+][0-9]{1,3}[ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/
      // console.log('validCellphone: ' + regex.test(this.item_handy))
      return regex.test(this.item_handy)
    },

    getTip() {
      const tip = parseFloat(this.item_tip)
      return !isNaN(tip) ? tip : 0
    },

    paymentSum() {
      if (this.item_homedelivery) {
        return (this.basketSum + this.shippingCosts) + parseFloat(this.getTip)
      } else {
        return this.basketSumWoMbw + parseFloat(this.getTip)
      }
    },

    calculatedShippingCosts() {
      if (this.item_homedelivery) {
        return this.shippingCosts
      }

      return 0
    },

    paymentSumWoShipping() {
      return this.paymentSum - this.calculatedShippingCosts
    },

    isOnlinePayment: function () {
      return [
        'paypal',
        'applepay',
        'googlepay'
      ].indexOf(this.item_payment) !== -1
    },

    hasExtraContent: function () {
      return String(this.item_xtra).length > 2
    },

    isExpressCheckout: function () {
      return [
        'applepay',
        'googlepay'
      ].indexOf(this.item_payment) !== -1
    },

    hasApplePay: function () {
      return (
        this.stripe &&
        window.ApplePaySession !== undefined &&
        (this.getBasket.currenthost.item_website_applekey || window.location.hostname.indexOf('strandbutler.menu') !== -1 || window.location.hostname.indexOf('foodi.de') !== -1 || window.location.hostname.indexOf('ngrok.io') !== -1)
      )
    },

    hasGooglePay() {
      return this.stripe && window.ApplePaySession === undefined
    },

    selectedGeoLocation() {
      try {
        return this.geoOptions.find(item => item.id === this.item_geoid)
      } catch (e) {
        // looks like geoOptions is not there yet. try again! yes, i know... sorry.
        // eslint-disable-next-line vue/no-async-in-computed-properties
        window.setTimeout(() => {
          this.updateStripePaymentRequest()
        }, 1000)

        return {
          item_ort_einfach: 'nicht angegeben'
        }
      }
    },

    deliverySelectionIsToday() {
      if (this.delivery == 0) return true
      return moment.unix(this.delivery).dayOfYear() === moment().dayOfYear()
    },

    filteredUserLocations() {
      return this.userLocations.filter(userLocation => {
        let found = false
        Object.values(this.geoOptions).forEach(geoOption => {
          if (userLocation.item_geoid === geoOption.id) {
            found = true
          }
        })

        return found
      })
    },

    hasValidMbwDeviation() {
      if (this.item_homedelivery === 'pickup') return true
      if (this.hasTable) return true
      return this.mbwDeviation <= this.getBasket.currenthost.item_max_mbw_deviation
    },

    hasVytalLoaded() {
      return (typeof VytalWebSdk === 'object')
    }
  },

  created() {
    this.getDeliveryOptions()
    this.getGeoOptions()

    if (!this.option_email || !this.option_whatsapp) {
      this.showNotificationSettings = true
    }
  },

  mounted() {
    this.initPayPal()
    this.initStripe()
    this.initVytal()
    this.checkSelectedPaymentMethod()

    window.eventBus.$on('reloadDeliveryOptions', () => {
      this.getDeliveryOptions()
    })
  },

  methods: {
    ...mapActions([
      'updateBasket',
      'cleanCustomerData'
    ]),

    ...mapMutations([
      'clearOfficeOrder',
      'setTable'
    ]),

    // set payment method to paypal if cash is selected but not allowed
    checkSelectedPaymentMethod() {
      if (this.item_payment === 'nachnahme' && this.getBasket.currenthost.item_payment_cash === 'N') {
        this.item_payment = 'paypal'
      }
    },

    getDeliveryOptions() {
      axios.post(endpoints.deliveryOptions, {
        'hostId': this.hostId,
        'type': (this.item_homedelivery ? 'delivery' : 'pickup')
      })
        .then(response => {
          this.deliveryOptions = response.data
          console.log([
            'validateSelectedDeliveryOption()',
            this.validateSelectedDeliveryOption()
          ])
        })
        .catch(e => {
          this.errors.push('Lieferoptionen konnten nicht geladen werden 😭')
        })
    },

    validateSelectedDeliveryOption() {
      if (this.delivery === 0) return true
      let match = false

      _.each(this.deliveryOptions, (e) => {
        if (typeof e.items === 'object') {
          _.each(e.items, (item) => {
            if (item.value == this.delivery) {
              match = true
            }
          })
        }
      })

      if (!match && !this.isOfficeOrderClient) {
        alert('Die ausgewählte Wunsch-' + (this.item_homedelivery ? 'Liefer' : 'Abhol') + 'zeit ist leider nicht mehr verfügbar. Bitte wähle eine der verfügbaren Optionen.')
      }
    },

    getGeoOptions() {
      axios.post(endpoints.geoOptions, { 'hostId': this.hostId })
        .then(response => {
          this.geoOptions = response.data.locations
        })
        .catch(e => {
          this.errors.push('Lieferorte konnten nicht geladen werden 😭')
        })
    },

    hostIsOpen() {
      return (this.getBasket.open.isOpen == 1)
    },

    tip(value) {
      const total = this.basketSum + (this.item_homedelivery ? this.shippingCosts : 0)

      if (value === 0) {
        const currentTotal = total + parseFloat(this.item_tip)
        const desiredTotal = Math.ceil(currentTotal)

        this.item_tip = (desiredTotal - total).toFixed(2)
      } else {
        this.item_tip = parseFloat((total) * (value / 100)).toFixed(2)
      }
    },

    validateForSendorder() {
      let errorCount = 0
      this.submitted = true

      const mandatoryNotExpressCheckout = [

      ]

      const mandatoryNotOfficeClient = [
        this.option_agb
      ]

      const mandatoryNotOfficeClientAndNotExpressCheckout = [
        this.item_vorname,
        this.item_name,
        this.item_handy,
        this.item_payment
      ]

      const mandatoryNotOfficeClientAndNotExpressCheckoutAndNotPos = [
        this.item_email
      ]

      const mandatoryHomedelivery = [
        this.item_strasse,
        this.item_hausnummer,
        this.item_geoid
      ]

      const mandatorySetup = _.merge(
        (!this.isExpressCheckout ? mandatoryNotExpressCheckout : {}),
        (!this.isOfficeOrderClient ? mandatoryNotOfficeClient : {}),
        (!this.isOfficeOrderClient && !this.isExpressCheckout ? mandatoryNotOfficeClientAndNotExpressCheckout : {}),
        (!this.isOfficeOrderClient && !this.isExpressCheckout && !this.isPosApp ? mandatoryNotOfficeClientAndNotExpressCheckoutAndNotPos : {}),
        (!this.isOfficeOrderClient && this.item_homedelivery && !this.isExpressCheckout ? mandatoryHomedelivery : {})
      )

      _.each(mandatorySetup, (e) => {
        errorCount += (e === null || e.length < 1)
        errorCount += Number(e === false)
      })

      if (this.delivery < 1 && !this.hostIsOpen() && !this.isOfficeOrderClient) {
        errorCount++
      }

      if (!this.hasTable) {
        if (errorCount > 0 || (!this.isOfficeOrderClient && !this.isExpressCheckout && !this.validCellphone)) {
          window.setTimeout(() => {
            alert('Bitte fülle alle Pflichtfelder korrekt aus')
          }, 100)
          return false
        }
      }

      return true
    },

    sendorder(event) {
      if (event) event.preventDefault()
      if (!this.validateForSendorder()) return

      if (this.$refs.orderform) this.$refs.orderform.classList.add('loading')

      axios.post(endpoints.order, {
        'hostId': window.hostId,
        'tableId': (this.hasTable ? this.getTable.tableId : null),
        'delivery': this.delivery,
        'homedelivery': this.item_homedelivery,
        'company': this.item_firma,
        'firstname': this.item_vorname,
        'lastname': this.item_name,
        'street': this.item_strasse,
        'number': this.item_hausnummer,
        'additional': this.item_address_addon,
        'geoid': this.item_geoid,
        'mobile': this.item_handy,
        'email': this.item_email,
        'payment': this.item_payment,
        'comment': this.item_xtra,
        'voucher': this.option_voucher,
        'cut': this.option_cut,
        'optionEmail': this.option_email,
        'optionWhatsapp': this.option_whatsapp,
        'bookatable': this.option_bookatable,
        'drop': this.option_drop,
        'insite': window.hostId,
        'officeId': this.officeOrder.officeOrderId,
        'tip': this.item_tip,
        'system': (window.type === 'customer' ? 'insite' : window.type),
        'v2': 'N',
        'saveAddress': this.storeCustomerAddress,
        'customerLocation': this.item_customer_location,
        'vytal': this.item_vytal
      })
        .then(response => {
          if (this.$refs.orderform) this.$refs.orderform.classList.remove('loading')
          this.order = response.data
          this.updateBasket()
          this.submitted = false

          if (response.data === true) {
            this.cleanCustomerData(this.storeCustomerData)

            this.$router.push({ name: 'DankeBuero' })
          } else if (response.data.success) {
            this.cleanCustomerData(!this.isPosApp ? this.storeCustomerData : false)
            this.clearOfficeOrder()
            this.track(response.data, response.data.total)
            this.abortTableOrder()

            if (!this.isOfficeOrderClient && response.data.type === 'paypal') {
              this.readyForPaypalPayment = true

              if(this.paypalLegacyMode) {
                this.$router.push({
                  name: 'PayPal',
                  params: {
                    orderId: response.data.orderId
                  }
                })
              }
            } else if (!this.isOfficeOrderClient && response.data.type === 'giropay') {
              this.$router.push({ name: 'Giropay' })
            } else if (!this.isOfficeOrderClient && (response.data.type === 'applepay' || response.data.type === 'googlepay')) {
              axios.post(endpoints.stripePaymentIntent, {
                'orderId': response.data.orderId
              })
                .then(({ data }) => {
                  this.confirmStripePayment(data.client_secret)
                })
                .catch(e => {
                  this.errors.push('Zahlungsüberprüfung fehlgeschlagen 😭')
                })
            } else {
              this.$router.push({ name: 'Danke' })
            }
          } else if (response.data.exception) {
            alert('Leider konnte deine Bestellung nicht übermittelt werden (' + response.data.reason + ')')
            window.location.reload()
          }
        })
        .catch(e => {
          console.log(e)
          this.errors.push('Die Bestellung konnte nicht übertragen werden 😭')
          this.errors.push(e.message)
          if (this.$refs.orderform) this.$refs.orderform.classList.remove('loading')
        })
    },

    updateHomeDelivery() {
      if (this.getBasket.currenthost.item_active_delivery === 'N' || this.getBasket.currenthost.item_homedelivery === 'N') {
        this.item_homedelivery = false
      }
    },

    track(order, total) {
      window.dataLayer = window.dataLayer || []

      window.dataLayer.push({
        'event': 'conversion',
        'transactionId': parseInt(order.orderId),
        'transactionAffiliation': window.type,
        'transactionTotal': parseFloat(total)
      })
    },

    abortTableOrder() {
      this.setTable({ success: false })
    },

    waitForReadyForPaypalPayment() {
      // we need to wait for the order details this way - had no better idea
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          if (this.readyForPaypalPayment) {
            clearInterval(interval);
            resolve()
          }
        }, 100)
      })
    },

    initPayPal() {
      if(document.querySelector('.paypal-button-container') && document.querySelector('.paypal-button-container').querySelector('iframe') !== null) {
        console.log('paypal already initialized')
        return
      }

      if(!window.paypal) {
        console.warn('window.paypal not available - skip rendering PayPal buttons')
        return
      }

      window.paypal.Buttons({
        style: {
          shape: "pill",
          layout: "vertical",
          color: "gold",
          label: "buynow",
        },

        onInit: () => {
          this.paypalButtonReady = true
        },

        createOrder: async () => {
          // abort if form is not valid
          if(!this.validateForSendorder()) return

          this.paypalPaymentInProgress = true
          this.sendorder()
          await this.waitForReadyForPaypalPayment()

          try {
            const response = await axios.post(endpoints.paypalOrders, {
              'cart': {
                    id: this.order.orderId,
                    quantity: "1",
              }
            })

            const orderData = response.data

            if (orderData.id) {
              return orderData.id;
            }

            throw new Error(orderData.message || "Fehler bei PayPal");
          } catch (error) {
            console.error(error);
          }
        },

        onApprove: async (data, actions) => {
          console.log('paypal', 'onApprove called!')
          this.paypalPaymentInProgress = false

          try {
            const response = await axios.post(endpoints.paypalCapture + '/' + data.orderID)
            const orderData = response.data;
            // Three cases to handle:
            //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
            //   (2) Other non-recoverable errors -> Show a failure message
            //   (3) Successful transaction -> Show confirmation or thank you message

            const errorDetail = orderData && orderData.details && orderData.details[0];

            if (errorDetail && errorDetail.issue === "INSTRUMENT_DECLINED") {
              // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
              // recoverable state, per
              // https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
              return actions.restart();
            } else if (errorDetail) {
              // (2) Other non-recoverable errors -> Show a failure message
              throw new Error(
                `${errorDetail.description} (${orderData.debug_id})`
              );
            } else if (!orderData.purchase_units) {
              throw new Error(JSON.stringify(orderData));
            } else {
              // (3) Successful transaction -> Show confirmation or thank you message
              // Or go to another URL:  actions.redirect('thank_you.html');
              this.$router.push({ name: 'Danke' })

              // const transaction = (orderData && orderData.purchase_units && orderData.purchase_units[0] && orderData.purchase_units[0].payments && orderData.purchase_units[0].payments.captures && orderData.purchase_units[0].payments.captures[0]) || (orderData && orderData.purchase_units && orderData.purchase_units[0] && orderData.purchase_units[0].payments && orderData.purchase_units[0].payments.authorizations && orderData.purchase_units[0].payments.authorizations[0]);
              // alert(`Transaction ${transaction.status}: ${transaction.id}<br><br>See console for all available details`);
              // console.log(
              //   "Capture result",
              //   orderData,
              //   JSON.stringify(orderData, null, 2)
              // );
            }
          } catch (error) {
            console.error(error);
            alert(
              `Leider gab es einen Fehler bei der PayPal Zahlung:
              ${error}`
            );
          }
        },

        onCancel: (data) => {
          window.location.assign("/archiv")
        },
      },)
        .render(".paypal-button-container")
    },

    initVytal() {
      // skip on staging
      if(document.location.hostname.includes('staging')) return

      if (this.hasVytalLoaded) {
        const scope = this

        VytalWebSdk.init(document.getElementById('vytal-login'), {
          clientId: "eac_foodi",
          onLoginCallback: function (result) {
            scope.item_vytal = result
          },
          onLogoutCallback: function () {
            scope.item_vytal = {}
          },
          disableAutoLogin: false
        })
      }
    },

    initStripe() {
      if (this.stripePaymentRequest !== null || [
        'applepay',
        'googlepay'
      ].indexOf(this.item_payment) === -1) {
        return
      }

      if (this.mbwDeviation > 5 && this.item_homedelivery) {
        return
      }

      if (this.isOfficeOrderClient) {
        return
      }

      const stripe = this.stripe
      const paymentRequestSettings = {
        country: 'DE',
        currency: 'eur',
        total: {
          label: 'Deine Bestellung bei ' + this.getBasket.currenthost.item_name,
          amount: Math.round(this.paymentSumWoShipping * 100)
        },
        requestPayerName: true,
        requestPayerEmail: true,
        requestPayerPhone: true,
        requestShipping: true, // this.item_homedelivery,
        shippingOptions: [
          {
            id: 'default',
            label: this.item_homedelivery ? 'Lieferung nach ' + this.selectedGeoLocation.item_ort_einfach : 'Abholung',
            detail: '',
            amount: (this.calculatedShippingCosts * 100)
          }
        ]
      }

      this.stripePaymentRequest = stripe.paymentRequest(paymentRequestSettings)

      const elements = stripe.elements()
      const prButton = elements.create('paymentRequestButton', {
        paymentRequest: this.stripePaymentRequest
      })

      // Check the availability of the Payment Request API first.
      this.stripePaymentRequest.canMakePayment().then((result) => {
        if (result) {
          prButton.mount('#payment-request-button')
        } else {
          this.paymentError = true
        }
      })

      this.stripePaymentRequest.on('paymentmethod', (ev) => {
        this.stripeEv = ev
        this.updateOrderAndSendOrder(ev)
      })

      prButton.on('click', () => {
        this.stripeHasActivePayment = true
      })

      this.stripePaymentRequest.on('cancel', () => {
        this.stripeHasActivePayment = false
      })
    },

    updateStripePaymentRequest() {
      if (!this.stripePaymentRequest) {
        // init if there is no existing stripePaymentRequest
        console.log(['updateStripePaymentRequest', 'init if there is no existing stripePaymentRequest'])
        this.initStripe()
        return
      }

      if (this.stripeHasActivePayment) {
        console.log(['updateStripePaymentRequest', 'quit because stripeHasActivePayment'])
        // skip is we have an open payment modal
        return
      }

      this.stripePaymentRequest.update({
        total: {
          label: 'Deine Bestellung bei ' + this.getBasket.currenthost.item_name,
          amount: Math.round(this.paymentSumWoShipping * 100)
        },
        shippingOptions: [
          {
            id: 'default',
            label: this.item_homedelivery ? 'Lieferung nach ' + this.selectedGeoLocation.item_ort_einfach : 'Abholung',
            detail: '',
            amount: (this.calculatedShippingCosts * 100)
          }
        ]
      })
    },

    confirmStripePayment(clientSecret) {
      const ev = this.stripeEv

      this.stripe.confirmCardPayment(
        clientSecret,
        {
          payment_method: ev.paymentMethod.id
        },
        {
          handleActions: false
        }
      ).then((confirmResult) => {
        if (confirmResult.error) {
          ev.complete('fail')
          alert('Fehler bei der validierung deiner Zahlung 😭')
          this.$router.push({ name: 'Archiv' })
        } else {
          ev.complete('success')
          // Check if the PaymentIntent requires any actions and if so let Stripe.js
          // handle the flow. If using an API version older than "2019-02-11" instead
          // instead check for: `paymentIntent.status === "requires_source_action"`.
          if (confirmResult.paymentIntent.status === 'requires_action') {
            this.stripe.confirmCardPayment(clientSecret).then((result) => {
              if (result.error) {
                alert('Fehler bei der validierung deiner Zahlung 😭')
                this.$router.push({ name: 'Archiv' })
              } else {
                this.updateStipeOrder()
                this.$router.push({ name: 'Danke' })
              }
            })
          } else {
            this.updateStipeOrder()
            this.$router.push({ name: 'Danke' })
          }
        }
      })
    },

    updateOrderAndSendOrder(ev) {
      axios.post(endpoints.matchHostGeoId, {
        'data': {
          'host': this.getBasket.currenthost.id,
          'homedelivery': this.item_homedelivery,
          'zip': ev.shippingAddress.postalCode,
          'city': ev.shippingAddress.city
        }
      })
        .then(({ data }) => {
          if (data.success || !this.item_homedelivery) {
            this.item_geoid = data.geoId
            this.sendorder()
          } else {
            alert('Wir konnten deinen Wohnort nicht zuordnen 😬')
            return false
          }
        })
        .catch(e => {
          this.errors.push('Wir konnten deinen Wohnort nicht zuordnen 😬')
        })
    },

    updateStipeOrder() {
      axios.post(endpoints.updateOrderByUid, {
        'orderId': this.order.orderId,
        'uid': this.order.uid,
        'data': {
          'item_firma': this.stripeEv.shippingAddress.organization,
          'item_name': this.stripeEv.shippingAddress.recipient,
          'item_handy': this.stripeEv.payerPhone,
          'item_email': this.stripeEv.payerEmail,
          'item_strasse': this.stripeEv.shippingAddress.addressLine[0],
          'item_hausnummer': this.stripeEv.shippingAddress.addressLine[1],
          'item_address_addon': this.stripeEv.shippingAddress.dependentLocality,
          'zip': this.stripeEv.shippingAddress.postalCode,
          'city': this.stripeEv.shippingAddress.city
        }
      })
        .then(response => {
          console.log('order has been updated successfully')
        })
        .catch(e => {
          this.errors.push('Deine Bestellung konnte nicht aktualisiert werden 😭')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  border-bottom: 3px solid #b1c800;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Orderform.vue